import { render } from "./Sms.vue?vue&type=template&id=139f6607&scoped=true"
import script from "./Sms.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Sms.vue?vue&type=script&charset=utf-8&lang=js"

import "./Sms.vue?vue&type=style&index=0&id=139f6607&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-139f6607"]])

export default __exports__